// state
import axios from "axios";
import commonservice from "../../../shared/common.service";

const defaultState = () => ({
	entity: {
		id: null,
		categoryId: null,
		title: null,
		url: null,
		keywords: null,
		description: null,
		heading: null,
		shortDescription: null,
		fullDescription: null,
		altitude: null,
		estimationCost: null,
		duration: null,
		grade: null,
		location: null,
		coordinates: null,
		groupSize: null,
		firstAscent: null,
		bestSeason: null,
		autumnItinerary: null,
		springItinerary: null,
		costIncludes: null,
		costExcludes: null,
		additionalCostIncludes: null,
		additionalCostExcludes: null,
		notes: null,
		country: "Nepal",
	},
	categoryList: [],
	countryList: [
		{
			text: "Nepal",
			value: "Nepal",
		},
		{
			text: "India",
			value: "India",
		},
		{
			text: "Tibet",
			value: "Tibet",
		},
		{
			text: "Bhutan",
			value: "Bhutan",
		},
		{
			text: "Kailash",
			value: "Kailash",
		},
	],
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
	loadContent({}, { pagination, search }) {
		return new Promise((resolve, reject) => {
			var param = {
				descending:
					pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
				page: pagination.page,
				rowsPerPage: pagination.itemsPerPage,
				sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
				search: search,
			};
			axios
				.get("/content?" + commonservice.convertToQueryString(param))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	setContent({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.get("/content/" + id)
				.then((response) => {
					commit("SET_CONTENT", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	saveBasic({ commit, state }) {
		return new Promise((resolve, reject) => {
			let data = {
				categoryId: state.entity.categoryId,
				title: state.entity.title,
				url: state.entity.url,
				keywords: state.entity.keywords,
				description: state.entity.description,
				heading: state.entity.heading,
				shortDescription: state.entity.shortDescription,
				fullDescription: state.entity.fullDescription,
				country: state.entity.country,
				id: state.entity.id,
			};
			if (state.entity.id) {
				axios
					.patch("/basiccontent", data)
					.then((response) => {
						commit("SER_CONTENT_ID", response);
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			} else {
				axios
					.post("/basiccontent", data)
					.then((response) => {
						commit("SER_CONTENT_ID", response);
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	saveTripFacts({ commit, state }) {
		let data = {
			altitude: state.entity.altitude,
			bestSeason: state.entity.bestSeason,
			coordinates: state.entity.coordinates,
			duration: state.entity.duration,
			estimationCost: state.entity.estimationCost,
			grade: state.entity.grade,
			firstAscent: state.entity.firstAscent,
			groupSize: state.entity.groupSize,
			location: state.entity.location,
			id: state.entity.id,
		};
		return new Promise((resolve, reject) => {
			if (state.entity.id) {
				axios
					.patch("/tripcontent", data)
					.then((response) => {
						//commit("RESET");
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	saveItinerary({ commit, state }) {
		let data = {
			autumnItinerary: state.entity.autumnItinerary,
			springItinerary: state.entity.springItinerary,
			id: state.entity.id,
		};
		return new Promise((resolve, reject) => {
			if (state.entity.id) {
				axios
					.patch("/itinerarycontent", data)
					.then((response) => {
						//commit("RESET");
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	saveCostInfo({ commit, state }) {
		let data = {
			costExcludes: state.entity.costExcludes,
			costIncludes: state.entity.costIncludes,
			additionalCostExcludes: state.entity.additionalCostExcludes,
			additionalCostIncludes: state.entity.additionalCostIncludes,
			notes: state.entity.notes,
			id: state.entity.id,
		};
		return new Promise((resolve, reject) => {
			if (state.entity.id) {
				axios
					.patch("/costinfocontent", data)
					.then((response) => {
						commit("RESET");
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	deleteContent({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.delete("/content/" + id)
				.then((response) => {
					commit("RESET");
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	init({ commit }) {
		return new Promise((resolve, reject) => {
			axios
				.get("/list/category")
				.then((response) => {
					commit("SET_CATEGORY_LIST", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

// mutations
const mutations = {
	RESET(state) {
		const categoryList = state.categoryList;
		Object.assign(state, defaultState());
		state.categoryList = categoryList;
	},
	SET_CONTENT_DATA(state, data) {
		if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
			state[data.key][data.index][data.property] = data.value;
		} else if (
			Object.prototype.toString.call(state[data.key]) === "[object Object]"
		) {
			state[data.key][data.property] = data.value;
		} else state.entity[data.key] = data.value;
	},
	SET_CONTENT(state, data) {
		state.entity.id = data.id;
		state.entity.title = data.title;
		state.entity.url = data.url;
		state.entity.categoryId = data.categoryId;
		state.entity.keywords = data.keywords;
		state.entity.description = data.description;
		state.entity.heading = data.heading;
		state.entity.shortDescription = data.shortDescription;
		state.entity.fullDescription = data.fullDescription;
		state.entity.altitude = data.altitude;
		state.entity.estimationCost = data.estimationCost;
		state.entity.duration = data.duration;
		state.entity.grade = data.grade;
		state.entity.location = data.location;
		state.entity.coordinates = data.coordinates;
		state.entity.groupSize = data.groupSize;
		state.entity.firstAscent = data.firstAscent;
		state.entity.bestSeason = data.bestSeason;
		state.entity.autumnItinerary = data.autumnItinerary;
		state.entity.springItinerary = data.springItinerary;
		state.entity.costIncludes = data.costIncludes;
		state.entity.costExcludes = data.costExcludes;
		state.entity.additionalCostExcludes = data.additionalCostExcludes;
		state.entity.additionalCostIncludes = data.additionalCostIncludes;
		state.entity.notes = data.notes;
		state.entity.country = data.country;
	},
	SET_CATEGORY_LIST(state, data) {
		state.categoryList = data;
	},
	SER_CONTENT_ID(state, data) {
		state.entity.id = data.data;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
